import React, { useState } from 'react';
import { Grid, Typography, Card, CardContent, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { DropzoneArea } from 'react-mui-dropzone';
import FormData from 'form-data';
import { useSnackbar } from 'notistack';
import { styles } from './styles';
import { commonAPI } from '../../../api';

export const SystemPermission = () => {
    const [files, setFiles] = useState('');
    const [resetSystemPermissionsAction, { isLoading }] = commonAPI.useResetSystemPermissionsActionMutation();

    const { enqueueSnackbar } = useSnackbar();

    const handleFiles = (files) => {
        setFiles(files[0]);
    };

    const validate = async () => {
        if (!files) {
            enqueueSnackbar('Please select a file', {
                variant: 'error',
            });
            return;
        }
        try {
            const formData = new FormData();
            formData.append('configFile', files);
            const response = await resetSystemPermissionsAction(formData).unwrap();
            if (!response) return;
            if (response?.status === 'ERROR') throw new Error(response?.message);
            enqueueSnackbar(response?.message, {
                variant: 'success',
            });
        } catch (error) {
            if (error?.statusCode === 400) enqueueSnackbar(error?.data?.message, { variant: 'error' });
            else enqueueSnackbar(error?.message || 'Something went wrong!', { variant: 'error' });
        }
    };
    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">Upload System Permission file</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card>
                    <CardContent>
                        <Grid container justifyContent="center" alignItems="center" mt={2}>
                            <Grid item xs={12}>
                                <DropzoneArea
                                    dropzoneText="Drag and drop a file here or click"
                                    filesLimit={1}
                                    onChange={handleFiles}
                                    showAlerts={false}
                                    showPreviews={true}
                                    showPreviewsInDropzone={false}
                                    useChipsForPreview
                                    previewGridProps={{
                                        container: {
                                            spacing: 1,
                                            direction: 'row',
                                        },
                                    }}
                                    previewText="Selected files"
                                />
                                <LoadingButton
                                    sx={{
                                        mt: 2,
                                    }}
                                    loading={isLoading}
                                    variant="contained"
                                    color="primary"
                                    onClick={validate}
                                >
                                    Upload
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};
